import {
  AfterViewInit,
  Component,
  Directive,
  Input, ModelSignal, signal, Signal,
  TemplateRef, viewChild, model, contentChild, computed, effect,
} from '@angular/core';

import {NgxMasonryOptions, NgxMasonryComponent} from 'ngx-masonry';

interface CubeTemplateContext<T extends object> {
  $implicit: T;
  index: number;
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[cubeTemplate]',
  standalone: false,
})
export class CubeTemplateDirective<T extends object> {
  @Input() cubeTemplate!: T[]; // turn off strong type:  | '' | undefined

  static ngTemplateContextGuard<TContext extends object>(
    directive: CubeTemplateDirective<TContext>,
    context: unknown,
  ): context is CubeTemplateContext<TContext> {
    return true;
  }
}


@Component({
  selector: 'lib-cubes-manager',
  templateUrl: './cubes-manager.component.html',
  styleUrls: ['./cubes-manager.component.scss'],
  standalone: false,
})
export class CubesManagerComponent<T extends object> implements AfterViewInit {
  protected readonly cubeTemplate: Signal<TemplateRef<CubeTemplateDirective<T>> | undefined> = contentChild(CubeTemplateDirective, {read: TemplateRef});
  protected readonly cubeTemplateNull: Signal<TemplateRef<CubeTemplateDirective<T>> | null> = computed(() => this.cubeTemplate()?? null);

  readonly dataModel: ModelSignal<T[]> = model<T[]>([]);

  styleInitialized = false;

  public masonryOptions: NgxMasonryOptions = {
    gutter: '.gutter-sizer',
    columnWidth: '.grid-sizer',
    itemSelector: '.studio2wx-grid-element',
    percentPosition: true,
    initLayout: false,
  };

  masonry: Signal<NgxMasonryComponent | undefined> = viewChild(NgxMasonryComponent);
  viewInitialized = signal<boolean>(false);

  ngAfterViewInit(): void {
    this.viewInitialized.set(true);
  }

  constructor() {
    this.#masonryReload();
  }

  #masonryReload(): void {
    effect(() => {
      const dataModel = this.dataModel() ?? [];
      const masonry = this.masonry();
      const viewInitialized = this.viewInitialized();
      if (masonry && viewInitialized && dataModel) {
        masonry.reloadItems();
        if (this.styleInitialized) {
          masonry.layout();
        } else {
          this.#initializeMasonry(masonry);
        }
      }
    });
  }

  #initializeMasonry(m: NgxMasonryComponent): void {
    setTimeout(() => {
      this.styleInitialized = true;
      setTimeout(() => {
        m.layout();
      }, 100);
    });
  }
}
